import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../style.scss";

function ListIntegration(props) {
  const location = useLocation();
  const [integrations, setIntegrations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchResponse = await axios({
          method: "GET",
          url: props.chimeraserv.urlGet + "/integration/list",
          headers: {
            Authorization:
              "eyJ1c2VybmFtZSI6ImNoc0FkbWluIiwicGFzc3dvcmQiOiJhZG1pbiJ9",
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        setIntegrations(fetchResponse.data);
      } catch (error) {
        setIntegrations([]);
      }
    };
    fetchData();
  }, [props.chimeraserv.urlGet]);

  const valueChange = async (integration) => {
    const newStatus = integration.status === 1 ? 0 : 1;
    integration.status = newStatus;
    let dataToUpdate = { ...integration };
    try {
      await axios.put(
        props.chimeraserv.urlPost + "/integration/edit/" + integration._id,
        dataToUpdate,
        {
          headers: {
            Authorization: props.user.data.usrKey,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      setIntegrations((prev) =>
        prev.map((item) =>
          item._id === integration._id ? { ...item, status: newStatus } : item
        )
      );
    } catch (error) {
      console.error("Error updating outlet status:", error);
    }
  };

  return (
    <div className="integration-list-page">
      <h2 className="viewTitle">Integrations</h2>
      <div className="integration-grid">
        {integrations.length > 0 ? (
          integrations.map((integration) => (
            <div className="integration-card" key={integration._id}>
              <div className="integration-header">
                <span className="integration-name">{integration.name}</span>
                {props.user.data.level === 0 && (
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={!!integration.status}
                      onChange={() => valueChange(integration)}
                    />
                    <span className="slider"></span>
                  </label>
                )}
              </div>
              <div className="integration-actions">
                {props.user.data.level === 0 && (
                  <Link
                    to={
                      location.pathname.split("/").splice(0, 3).join("/") +
                      "/edit/" +
                      integration._id
                    }
                    state={{ data: integration }}
                    className="action-btn"
                  >
                    <FontAwesomeIcon icon={["fas", "cog"]} /> Edit
                  </Link>
                )}
                <Link
                  to={
                    location.pathname.split("/").splice(0, 3).join("/") +
                    "/view/" +
                    integration._id
                  }
                  state={{ data: integration }}
                  className="action-btn"
                >
                  <FontAwesomeIcon icon={["fas", "eye"]} /> View
                </Link>
                <Link
                  to={
                    location.pathname.split("/").splice(0, 3).join("/") +
                    "/push/" +
                    integration._id
                  }
                  state={{ data: integration }}
                  className="action-btn"
                >
                  <FontAwesomeIcon icon={["fas", "upload"]} /> Push
                </Link>
              </div>
            </div>
          ))
        ) : (
          <div className="no-integrations">No integrations found.</div>
        )}
      </div>
    </div>
  );
}

export default ListIntegration;
